import PATH from 'constants/basePath';

export default [
  PATH.SELECT_MODULE,
  PATH.SELECT_WORKSPACE.BASE_URL,
  PATH.SELECT_WORKSPACE.CREATE,
  PATH.SELECT_WORKSPACE.CREATE_CONSORTIUM,
  PATH.TICKET_RESERVATION_WEBSITE.TO_PAY,
  PATH.TICKET_RESERVATION_WEBSITE.MY_ORDERS,
  PATH.TICKET_RESERVATION_WEBSITE.MY_BPE,
  PATH.TICKET_RESERVATION_WEBSITE.PROFILE,
];
